import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import { Row, Col, Input } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import classnames from 'classnames';
import moment from 'moment';
import ModalActions from 'shared/flux/actions/ModalActions';
import PublishGlobalElementsActions from 'shared/flux/actions/PublishGlobalElementsActions';
import PublishGlobalElementsStore from 'shared/flux/stores/PublishGlobalElementsStore';
import GlobalElementStore from 'shared/flux/stores/GlobalElementStore';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';

// const RowSection = 'row';
// const ColumnSection = 'column';
// const CellSection = 'cell';
// const TrackingSection = 'tracking';
// const MiscSection = 'misc';

const geManagerShowId = 'geManagerShowId';

/**
 * Keyboard Shortcuts Modal
 */
export default React.createClass({
  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(PublishGlobalElementsStore, 'publishState'),
    Reflux.connect(GlobalElementStore, 'globalElement'),
    Reflux.connect(CuesheetStore, 'cuesheet'),
  ],

  displayName: 'PublishGlobalElementsChangesModal',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      searchFocusState: false,
    };
  },

  render() {
    const { publishState, globalElement } = this.state;

    const activeItem = this._getActiveItem();

    if (!activeItem) return null;

    const activeShowsCount = publishState.get('globalElementShowItems').size;
    const labelName = globalElement.getIn([
      'tags',
      activeItem.get('label'),
      'text',
    ]);

    const publishBtnDisabled =
      publishState.get('submitDisabled') ||
      publishState.get('selectedItems').size < 1
        ? true
        : false;

    const elementLabelNode = !isGlobalElementManager() ? null : (
      <Row>
        <Col lg={7} md={7} sm={7}>
          <div className="ge-publish-sub-title">Element Tags:</div>
        </Col>
        <Col lg={16} md={16} sm={16}>
          <div className="ge-publish-sub-text">{labelName}</div>
        </Col>
      </Row>
    );

    return (
      <Modal
        className="modal-generic-wrapper ge-publish-changes-modal"
        headerClassName="modal-generic-header"
        name={UIRegions.PublishGEChanges}
        title="Publish Element Changes"
        onHide={PublishGlobalElementsActions.clearSelection}
        autoFocus={false}
      >
        <div className="ge-publish-changes-modal-inner">
          {elementLabelNode}
          <Row>
            <Col lg={7} md={7} sm={7}>
              <div className="ge-publish-sub-title">Global Element:</div>
            </Col>
            <Col lg={16} md={16} sm={16}>
              <div className="ge-publish-sub-text">
                {activeItem.get('title')}
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={24} md={24} sm={24}>
              <p className="ge-paragraph">
                There are currently{' '}
                <span className="ge-emphasize">
                  {activeShowsCount} Active Shows
                </span>{' '}
                containing &nbsp;
                <span className="ge-emphasize">{labelName}</span> global
                element.
              </p>
              <p>Select the shows you wish to publish your changes to.</p>
            </Col>
          </Row>
          <Row>
            {this._getItemControls()}
            {this._getItems(publishState.get('globalElementShowItems'))}
          </Row>
          <Row>
            <Col lg={24} md={24} sm={24}>
              <div className="ge-publish-changes-action-btns">
                <button
                  className="ge-cancel-btn"
                  onClick={() => this._cancelChanges()}
                >
                  Cancel
                </button>
                <button
                  tabIndex={1}
                  ref={(node) => (this.publishButton = node)}
                  disabled={publishBtnDisabled}
                  className="ge-publish-btn"
                  onClick={() => this._publishChanges()}
                >
                  {publishState.get('submitText')}
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  },

  _getActiveItem() {
    const { cuesheet, publishState } = this.state;

    return cuesheet.getIn([
      'rowMap',
      publishState.get('itemSetId'),
      'rows',
      publishState.get('rowId'),
      'item',
    ]);
  },

  _getItemControls() {
    const { searchFocusState, publishState } = this.state;
    const hasValue = this._checkSearchValue();
    let searchTerm = publishState.get('searchTerm');

    return (
      <div className="ge-publish-item-controls-wrapper">
        <div className="ge-publish-item-controls left">
          <input
            className="ge-publish-item-controls-input"
            type="checkbox"
            checked={publishState.get('allItemsSelected')}
            onClick={() => this._handleAllItemSelection()}
          />
          <div
            onClick={() => this._handleAllItemSelection()}
            className="ge-publish-item-controls-title all"
          >
            Select All
          </div>
        </div>
        <div className="ge-publish-search-wrapper ge-publish-item-controls right">
          <div className="search-container-header-input">
            <span
              className={classnames('search-wrapper', {
                'has-focus': searchFocusState,
              })}
            >
              <Input
                type="text"
                placeholder="Search for show"
                className={classnames('search-input', {
                  'has-value': hasValue,
                })}
                value={searchTerm}
                addonBefore={<span>{this._getSearchPreControl()}</span>}
                onChange={(e) => this._handleSearchChange(e.target.value)}
                onFocus={() => this._toggleSearchInputFocus()}
                onBlur={() => this._toggleSearchInputFocus()}
              />
            </span>
          </div>
        </div>
      </div>
    );
  },

  _getItems(items) {
    let { publishState } = this.state;
    let searchedItems = publishState.get('searchedItems');

    if (searchedItems) items = searchedItems;
    let itemsArray = items.toArray ? items.toArray() : items;

    return (
      <div className="ge-publish-items">
        {itemsArray.map((item, index) => {
          if (item.get('_id') === geManagerShowId)
            return this._getGEManagerItem(item);
          return this._getItem(item, index);
        })}
      </div>
    );
  },

  _getGEManagerItem(item) {
    const { publishState, globalElement } = this.state;
    const itemId = item.get('_id');
    const isSelected = publishState.getIn(['selectedItems', itemId]) || false;

    return (
      <Col
        key={geManagerShowId}
        className="ge-publish-item-col-ge"
        lg={12}
        md={12}
      >
        <div
          className={classnames('ge-publish-item', { selected: isSelected })}
          onClick={() => this._handleItemSelection(itemId)}
        >
          <div className="ge-publish-item-show-title">
            {globalElement.getIn(['activeElementSet', 'title'])}
          </div>
          <div className="ge-publish-item-show-ge-label">
            GLOBAL ELEMENT MANAGER
          </div>
        </div>
      </Col>
    );
  },

  // eslint-disable-next-line no-unused-vars
  _getItem(item, index) {
    const { publishState } = this.state;
    const itemId = item.get('_id');
    const isSelected = publishState.getIn(['selectedItems', itemId]) || false;

    const templateNode = item.getIn(['show', 'template']) ? (
      <div className="ge-publish-item-template-label">TEMPLATE</div>
    ) : null;

    return (
      <Col key={itemId} className="ge-publish-item-col" lg={12} md={12}>
        <div
          className={classnames('ge-publish-item', { selected: isSelected })}
          onClick={() => this._handleItemSelection(itemId)}
        >
          <div className="ge-publish-item-show-title">
            {item.getIn(['show', 'title'])}
          </div>
          <div className="ge-publish-item-event-title">
            {item.getIn(['event', 'title'])}
          </div>
          <div className="ge-publish-item-show-start-date">
            {moment(item.getIn(['show', 'startOn'])).format('M/D/YY')}
          </div>
          {templateNode}
        </div>
      </Col>
    );
  },

  _handleItemSelection(itemId) {
    PublishGlobalElementsActions.toggleItemSelection(itemId);
  },

  _handleAllItemSelection() {
    PublishGlobalElementsActions.toggleAllItemSelection();
    //we wrap the focus() call with setTimeout(), which effectively defers the work until
    //the end of the execution queue, to allow time for the disabled button to become selectable
    setTimeout(() => {
      this.publishButton.focus();
    }, 0);
  },

  _publishChanges() {
    const { publishState } = this.state;

    const updateGlobalElementManager = publishState.getIn([
      'selectedItems',
      geManagerShowId,
    ]);
    const selectedItems = publishState
      .get('selectedItems')
      .delete(geManagerShowId);
    const geShowItemIds = selectedItems.keySeq().toArray();

    let showIds = [];

    geShowItemIds.forEach((id) => {
      showIds.push(
        publishState.getIn(['globalElementShowItems', id, 'show', '_id']),
      );
    });

    const publishAction = isGlobalElementManager()
      ? PublishGlobalElementsActions.publishChanges
      : PublishGlobalElementsActions.publishChangesEverywhere;

    publishAction(
      publishState.get('teamId'),
      publishState.get('eventId'),
      publishState.get('showId'),
      publishState.get('itemSetListId'),
      publishState.get('itemSetId'),
      publishState.get('rowId'),
      showIds,
      !!updateGlobalElementManager,
    );
  },

  _cancelChanges() {
    ModalActions.hide(UIRegions.PublishGEChanges);
    PublishGlobalElementsActions.clearSelection();
  },

  _toggleSearchInputFocus() {
    let { searchFocusState } = this.state;
    this.setState({ searchFocusState: !searchFocusState });
  },

  _checkSearchValue() {
    let { publishState } = this.state;
    const searchedItems = publishState.get('searchedItems');

    if (searchedItems) {
      return true;
    }

    return false;
  },

  _getSearchPreControl() {
    let searchNode = (
      <span className="search-prefix-wrapper">
        <Icon name="search" />
      </span>
    );
    let removeNode = (
      <span
        onClick={() => this._clearSearchTerm()}
        className="search-prefix-wrapper remove"
      >
        <Icon name="times" />
      </span>
    );

    return this._checkSearchValue() ? removeNode : searchNode;
  },

  _clearSearchTerm() {
    PublishGlobalElementsActions.clearSearch();
  },

  _handleSearchChange(searchTerm) {
    PublishGlobalElementsActions.searchItems(searchTerm);
  },
});
